export const pickLiveOrPreliveId = (marketConfig, isLive) => {
    return isLive
        ? marketConfig.idLive
        : marketConfig.idPreLive;
};
//# sourceMappingURL=pickLiveOrPreliveId.js.map